import React, { useState } from "react";
import { FaStar } from "react-icons/fa";
import { useAuth } from "../../context/AuthContext";
import api from "../../services/axiosInstance";

const RateProfessorModal = ({ profId, onClose, onSubmitted }) => {
  const { user } = useAuth();
  const [rating, setRating] = useState(5);
  const [hover, setHover] = useState(null);
  const [review, setReview] = useState("");

  const submitRating = async () => {
    if (!user) {
  alert("Please log in to rate");
  onClose();
  return null;
}
    try {
      await api.post("/users/rate", {
        profId,
        userId: user.id,
        rating,
        review
      });
      onSubmitted();
      onClose();
    } catch (err) {
      console.error(err);
      alert("Error submitting rating");
    }
  };

  return (
    <div onClick={onClose} className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div onClick={(e) => e.stopPropagation()} className="bg-white p-6 rounded-lg w-80">
        <h2 className="text-lg font-bold mb-4">Rate Professor</h2>

        <div className="flex mb-4">
          {[...Array(5)].map((_, i) => (
            <FaStar
              key={i}
              size={30}
              className={`cursor-pointer ${i < (hover || rating) ? "text-yellow-400" : "text-gray-300"}`}
              onClick={() => setRating(i + 1)}
              onMouseEnter={() => setHover(i + 1)}
              onMouseLeave={() => setHover(null)}
            />
          ))}
        </div>


        <div className="flex justify-end gap-2">
          <button className="px-4 py-2 bg-gray-200 rounded" onClick={onClose}>Cancel</button>
          <button className="px-4 py-2 bg-blue-600 text-white rounded" onClick={submitRating}>Submit</button>
        </div>
      </div>
    </div>
  );
};

export default RateProfessorModal;